// 购物车抽屉组件
<template>
  <el-drawer :visible.sync="visible" size="332px" custom-class="help-drawer" :with-header="false">
    <div class="header p-r">
      <h3>{{ $t('Components.HelpCenter.Tutorial') }}</h3>
      <i class="iconfont icon-a-close-line1 close pointer" @click="close"></i>
    </div>

    <vue-scroll style="height: calc(100vh - 120px);">
      <div class="list">
        <div class="item pointer" @click="openWindow('/tutorial-1')">
          <h3 class="ellipsis title">{{ $t('Components.HelpCenter.Tips1') }}</h3>
          <iframe width="233" height="125" src="https://www.youtube.com/embed/UioOMgDxyCI" :title="$t('Components.HelpCenter.YouTubeVideoPlayer')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          <p>{{ $t('Components.HelpCenter.Tips2') }} </p>
        </div>

        <div class="line"></div>

        <div class="item pointer" @click="openWindow('/tutorial-2')">
          <h3 class="ellipsis title">{{ $t('Components.HelpCenter.Tips3') }}</h3>
          <iframe width="233" height="125" src="https://www.youtube.com/embed/GShwa_f94so" :title="$t('Components.HelpCenter.YouTubeVideoPlayer')" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          <p>{{ $t('Components.HelpCenter.Tips4') }}</p>
          <p>{{ $t('Components.HelpCenter.Tips5') }}</p>
          <p>{{ $t('Components.HelpCenter.Tips6') }}</p>
          <p>{{ $t('Components.HelpCenter.Tips7') }}</p>
        </div>

        <div class="line"></div>

        <div class="item pointer" @click="openWindow('/tutorial-3')">
          <h3 class="ellipsis title">{{ $t('Components.HelpCenter.Tips8') }}</h3>
          <p>{{ $t('Components.HelpCenter.Tips9') }}</p>
          <h4 class="f-c"><img style="max-width:80%" src="@/assets/img/help-center/tutorial3_1.png" alt=""></h4>
          <p>{{ $t('Components.HelpCenter.Tips10') }}</p>
        </div>
      </div>
    </vue-scroll>

    <div class="f-c-c footer pointer" @click="openWindow('/help-center')">
      <i class="iconfont icon-help"></i>
      <span style="padding-left: 8px;">{{ $t('Components.HelpCenter.HelpCenter') }}</span>
    </div>
	</el-drawer>
</template>

<script>
export default {
  data() {
    return {
      visible: false
    }
  },
  created() {

  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    openWindow(path) {
      console.log(path)
      window.open(path)
    }
  }
}
</script>

<style lang="scss" scoped>
.header{
	width: 332px;
  padding: 25px;
	border: 0.5px solid #CDD4DD;
	h3{
		font-weight: 500;
		font-size: 18px;
		color: #000000;
	}
	.checkbox{
		font-size: 14px;
		line-height: 21px;
		color: #8B93A3;
	}
	.close{
		position: absolute;
		top: 25px;
		right: 20px;
		font-size: 20px;
	}
}
.list{
  padding: 18px;
  width: 332px;
  line-height: 22px;
  font-weight: 400;
  color: #8B93A3;

  .title{
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #000000;
    padding-bottom: 15px;
  }
  .line{
    background: #CDD4DD;
    height: 0.5px;
    margin: 15px 0;
  }
}
.footer{
  width: 100%;
  height: 43px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
<style lang="scss">
.help-drawer .el-drawer__body{
  overflow-x: hidden!important;
}
.help-drawer .header{
  padding: 20px 25px;
}
.help-drawer .icon-a-close-line1{
  top: 20px!important;
}
</style>
